/**
 * Risk değerlendirmesi ekranının metinleri (M13d; ADR 0050; `gemi-risk-degerlendirme.jpeg`).
 * Bölüm adları tasarımdaki gibi İngilizce; Türkçe ikinci dil.
 */

export const riskEn = {
  title: 'Risk Assessment',
  crumbList: 'Risk Assessment List',
  description:
    'Risk assessments of shipboard activities (ISM 1.2.2.2): hazards, 5×5 scoring before and after controls, approval and review.',
  newAssessment: 'New Risk Assessment',
  export: 'Export',
  print: 'Print',
  kpi: {
    total: 'Total Risk',
    totalNote: 'Assessments in the list',
    high: 'High Risk',
    highNote: 'Action required',
    medium: 'Medium Risk',
    mediumNote: 'Monitoring',
    low: 'Low Risk',
    lowNote: 'Under control',
  },
  filter: {
    label: 'Filter risk assessments',
    vessel: 'Vessel',
    allVessels: 'All Vessels',
    department: 'Department',
    allDepartments: 'All Departments',
    category: 'Risk Category',
    allCategories: 'All Categories',
    level: 'Risk Level',
    allLevels: 'All Levels',
    status: 'Status',
    allStatuses: 'All Status',
    from: 'Assessed from',
    to: 'Assessed to',
    search: 'Search',
    text: 'Title or number',
    cell: 'Matrix: likelihood {{likelihood}} × impact {{severity}}',
    clearCell: 'Clear matrix filter',
  },
  matrix: {
    title: '1. Risk Matrix',
    likelihood: 'Likelihood',
    impact: 'Impact',
    initial: 'Initial risk',
    residual: 'Residual risk',
    mode: 'Risk shown',
    cell: 'Likelihood {{likelihood}}, impact {{severity}}: {{count}} assessments. Show them in the list.',
  },
  list: {
    title: '2. Risk List',
    table: 'Risk assessments',
    columns: {
      no: 'No',
      raNo: 'RA No',
      title: 'Title',
      vessel: 'Vessel',
      department: 'Department',
      level: 'Risk Level',
      score: 'Score',
      status: 'Status',
      actions: 'Actions',
    },
    view: 'View {{no}}',
    edit: 'Edit {{no}}',
    showing: 'Showing {{from}}–{{to}} of {{total}}',
    pagination: 'Risk list pages',
    emptyTitle: 'No risk assessments yet',
    emptyShip: 'Start one from a scenario in the library below, or with New Risk Assessment.',
    emptyWeb: 'Risk assessments are written on board and reach the office with synchronisation.',
    noMatch: 'No risk assessment matches the filters',
    error: 'The risk assessments could not be loaded.',
    unscored: 'Not scored',
    changed: 'Revision in progress',
    office: 'Office',
  },
  form: {
    title: '3. Risk Assessment Form (New/Edit)',
    noneTitle: 'Select a risk assessment',
    noneText: 'Choose one in the list, or start a new one.',
    tabs: {
      general: 'General',
      details: 'Risk Details',
      controls: 'Control Measures',
      history: 'Revision History',
    },
    vessel: 'Vessel',
    department: 'Department',
    category: 'Risk Category',
    titleField: 'Title',
    activity: 'Description',
    location: 'Location',
    likelihood: 'L (Likelihood)',
    impact: 'I (Impact)',
    level: 'Risk Level',
    residual: 'Residual Risk',
    assessedBy: 'Assessed By',
    assessmentDate: 'Assessment Date',
    reviewDate: 'Review Date',
    template: 'From template {{code}} (version {{version}})',
    source: 'From company RA {{code}}',
    revision: 'Revision {{no}}',
    inForce: 'Revision {{no}} in force',
    save: 'Save',
    cancel: 'Cancel',
    saved: 'Saved.',
    submit: 'Submit for approval',
    submitRevision: 'Submit revision',
    approve: 'Approve',
    return: 'Return',
    withdraw: 'Withdraw',
    discard: 'Discard draft',
    readOnlyOffice: 'Risk assessments are written on board. The office reviews and approves them.',
    pendingShip: 'Waiting for step {{step}} of {{steps}} on board.',
    pendingOffice: 'Waiting for the office approval (step {{step}} of {{steps}}).',
    returnedNote: 'Returned. Correct it and submit it again with a reason.',
    changedNote: 'Changes after the last submission. Submit them as a new revision with a reason.',
    hazards: {
      add: 'Add hazard',
      hazard: 'Hazard',
      consequence: 'Consequence / who is at risk',
      likelihood: 'L',
      severity: 'I',
      initial: 'Initial',
      residualLikelihood: 'Residual L',
      residualSeverity: 'Residual I',
      residual: 'Residual',
      remove: 'Remove hazard {{n}}',
      empty: 'No hazards yet. Add the hazards of this activity.',
      table: 'Hazards',
    },
    controls: {
      hazard: 'Hazard',
      general: 'General',
      remove: 'Remove control measure {{n}}',
      table: 'Control measures being edited',
    },
    matrix: 'Risk matrix: {{name}}',
    history: {
      matrix: 'Risk matrix: {{name}}',
      empty: 'Not submitted yet. The first submission becomes revision 1.',
      submitted: 'Submitted {{at}} by {{by}}',
      reason: 'Reason: {{reason}}',
      decision: 'Step {{step}}: {{decision}} by {{by}} ({{role}}) on {{at}}',
      office: 'office',
      outcomes: {
        pending: 'Pending',
        approved: 'Approved',
        returned: 'Returned',
        superseded: 'Superseded',
      },
    },
  },
  controls: {
    title: '4. Control Measures',
    table: 'Control measures',
    columns: {
      type: 'Type',
      measure: 'Control Measure',
      responsible: 'Responsible',
      dueDate: 'Due Date',
      status: 'Status',
    },
    add: 'Add Control Measure',
    empty: 'No control measures yet.',
    none: 'Select a risk assessment to see its control measures.',
  },
  guide: {
    title: '5. Risk Scoring Guide',
    impact: 'Impact (Severity)',
    likelihood: 'Likelihood',
    severity: {
      1: 'Minor (first aid)',
      2: 'Lost time < 1 day',
      3: 'Lost time 1–7 days',
      4: 'Major injury / damage',
      5: 'Fatality / major loss',
    },
    probability: {
      1: 'Rare (< 1 a year)',
      2: 'Unlikely (1–2 a year)',
      3: 'Possible (once a month)',
      4: 'Likely (once a week)',
      5: 'Almost certain (continuous)',
    },
  },
  scale: {
    1: 'Very Low',
    2: 'Low',
    3: 'Medium',
    4: 'High',
    5: 'Very High',
  },
  scenarios: {
    title: '6. Risk Scenarios (Library)',
    note: 'Published company risk assessments. A vessel assessment starts from a current version assigned to this vessel.',
    use: 'Start from {{title}}',
    empty: 'The company has not published a risk assessment yet.',
    error: 'The company risk library could not be loaded.',
    not_assigned: 'Not assigned',
    superseded: 'Superseded',
  },
  start: {
    title: 'New vessel risk assessment',
    version: 'Company risk assessment',
    help: 'Only the current versions assigned to this vessel can be used.',
    placeholder: 'Pick a published assessment',
    none: 'No company risk assessment is assigned to this vessel.',
    residualNote:
      'The residual risk starts equal to the initial risk: lower it once the controls are verified on board.',
    start: 'Start Assessment',
  },
  library: {
    titleNew: 'New template',
    titleEdit: 'Edit template {{code}}',
    code: 'Code',
    save: 'Save template',
    archive: 'Archive template',
    archiveConfirm: 'Archive this template? Vessel copies are not affected.',
    version: 'Version {{version}}',
  },
  tree: {
    title: '7. Decision Tree (Risk Assessment Process)',
    identified: 'Hazard identified?',
    assess: 'Assess the risk (Likelihood × Impact)',
    high: 'Is the risk level high?',
    plan: 'Create an action plan (preventive / corrective)',
    monitor: 'Monitor and review',
    yes: 'Yes',
    no: 'No',
    frequency: 'Risk assessment frequency',
    when: {
      before: 'Before every new activity',
      yearly: 'At least once a year',
      change: 'After significant changes',
      incident: 'After an incident or accident',
    },
  },
  dialog: {
    password: 'Password',
    reason: 'Reason',
    cancel: 'Cancel',
    submitTitle: 'Submit for approval',
    submitBody:
      'The assessment becomes revision {{no}} and cannot be changed afterwards. Enter your password to sign.',
    approveTitle: 'Approve risk assessment',
    approveBody: 'You approve revision {{no}} as shown. Enter your password to sign.',
    returnTitle: 'Return risk assessment',
    returnBody: 'Write what must be corrected. Enter your password to sign.',
    withdrawTitle: 'Withdraw risk assessment',
    withdrawBody:
      'The assessment stays in the history and can no longer be used. This cannot be undone.',
    discardTitle: 'Discard draft',
    discardBody: 'The draft is removed from the list; its number is kept.',
  },
  departments: {
    deck: 'Deck',
    engine: 'Engine',
    catering: 'Catering',
    operations: 'Operations',
    crew: 'Crew',
    other: 'Other',
  },
  categories: {
    mooring: 'Mooring',
    navigation: 'Navigation',
    cargo: 'Cargo operations',
    fire: 'Fire',
    chemical: 'Chemical exposure',
    work_at_height: 'Work at height',
    enclosed_space: 'Enclosed space',
    hot_work: 'Hot work',
    equipment: 'Equipment failure',
    fatigue: 'Fatigue',
    security: 'Security',
    other: 'Other',
  },
  levels: {
    very_low: 'Very Low',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    very_high: 'Very High',
    critical: 'Critical',
  },
  statuses: {
    draft: 'Draft',
    pending: 'Pending approval',
    returned: 'Returned',
    approved: 'Approved',
    withdrawn: 'Withdrawn',
    discarded: 'Discarded',
  },
  review: {
    due: 'Review due',
    overdue: 'Review overdue',
  },
  controlTypes: {
    elimination: 'Elimination',
    substitution: 'Substitution',
    engineering: 'Engineering',
    administrative: 'Administrative',
    ppe: 'PPE',
    training: 'Training',
  },
  controlStatuses: {
    planned: 'Planned',
    open: 'Open',
    in_progress: 'In Progress',
    done: 'Done',
  },
  matrixProfile: {
    title: 'Risk Matrix',
    intro:
      'Score = likelihood × severity (5 × 5). The bands and their acceptance level are a company setting. Publishing creates a new version; earlier versions are kept, and every submitted assessment keeps the version it was submitted with.',
    shipNote: 'The risk matrix is set in the office and reaches the vessel with the next sync.',
    profile: 'Profile',
    inUse: 'In use',
    use: 'Use this profile',
    versionLabel: '{{name}} v{{version}}',
    legacy: 'Legacy 5-band',
    bands: 'Bands',
    band: 'Band',
    score: 'Score',
    to: 'Up to',
    acceptance: 'Acceptance',
    acceptedBy: 'Accepted by',
    addBand: 'Add band',
    removeBand: 'Remove band {{n}}',
    acceptances: {
      acceptable: 'Acceptable',
      controls_required: 'Requires additional controls',
      escalation: 'Escalation required',
      unacceptable: 'Unacceptable',
    },
    acceptors: { master: 'Master', superintendent: 'Superintendent', dpa: 'DPA' },
    preview: 'Preview',
    cell: 'Likelihood {{likelihood}} × Severity {{severity}} = {{score}}, {{level}}',
    reason: 'Reason for the change',
    reasonHint: 'At least 5 characters; kept with the version.',
    publish: 'Publish version {{version}}',
    published: 'Version {{version}} published. It reaches the vessels with the next sync.',
    selected: 'Profile changed. New risk assessment revisions use it.',
    history: 'Version history',
    historyItem: 'Version {{version}} · {{at}} · {{by}}',
    issues: {
      MATRIX_BOUNDS: 'The bands must start at 1 and end at 25.',
      MATRIX_GAP: 'Band {{n}} leaves a gap after the band before it.',
      MATRIX_OVERLAP: 'Band {{n}} overlaps the band before it.',
      MATRIX_EMPTY_BAND: 'Band {{n}} is empty: its upper limit is below its lower limit.',
      MATRIX_BAND_ORDER: 'Band {{n}}: band names must go from low to high.',
      MATRIX_ACCEPTANCE_ORDER: 'Band {{n}} cannot be more lenient than the band below it.',
      MATRIX_ACCEPTOR_REQUIRED: 'Band {{n}} needs at least one role who accepts the residual risk.',
      MATRIX_ACCEPTOR_NOT_ALLOWED:
        'Band {{n}}: nobody accepts the residual risk of an unacceptable band, and a role is listed once.',
    },
    error: 'The risk matrix could not be saved.',
    retry: 'Try again',
  },
  errors: {
    GENERIC: 'The operation failed. Try again.',
    NETWORK: 'No connection. Check the network and try again.',
    FORBIDDEN: 'You are not allowed to do this.',
    NOT_FOUND: 'The risk assessment was not found.',
    INVALID_CREDENTIALS: 'The password is wrong.',
    INVALID_PASSWORD: 'The password is wrong.',
    TOO_MANY_ATTEMPTS: 'Too many wrong passwords. Wait 15 minutes and try again.',
    ROW_VERSION_CONFLICT: 'Someone else changed this assessment. Reopen it and try again.',
    INVALID_RISK_ASSESSMENT: 'Some fields are empty or invalid.',
    INVALID_RISK_TEMPLATE: 'Some fields of the template are empty or invalid.',
    ACTIVITY_REQUIRED: 'Describe the activity before submitting.',
    NO_HAZARDS: 'Add at least one hazard.',
    RESIDUAL_ABOVE_INITIAL: 'The residual risk cannot be higher than the initial risk.',
    CONTROLS_REQUIRED:
      'Every hazard whose initial risk is above the acceptable band needs a control measure.',
    RESIDUAL_INTOLERABLE:
      'The residual risk is in an unacceptable band of the risk matrix. Add controls.',
    INVALID_RISK_MATRIX: 'The risk matrix is invalid.',
    MATRIX_BOUNDS: 'The bands must start at 1 and end at 25.',
    MATRIX_GAP: 'The bands leave a gap.',
    MATRIX_OVERLAP: 'The bands overlap.',
    MATRIX_EMPTY_BAND: 'A band is empty.',
    MATRIX_BAND_ORDER: 'Band names must go from low to high.',
    MATRIX_ACCEPTANCE_ORDER: 'A higher band cannot be more lenient than a lower band.',
    MATRIX_ACCEPTOR_REQUIRED: 'An escalation band needs a role who accepts the residual risk.',
    MATRIX_ACCEPTOR_NOT_ALLOWED: 'Nobody accepts the residual risk of an unacceptable band.',
    UNKNOWN_MATRIX_PROFILE: 'The risk matrix profile was not found.',
    MATRIX_VERSION_MISMATCH: 'The risk matrix changed meanwhile. Reopen the page and try again.',
    FUTURE_DATE: 'The assessment date cannot be in the future.',
    REVIEW_BEFORE_ASSESSMENT: 'The review date must be after the assessment date.',
    REVIEW_TOO_LATE: 'The review date can be at most 12 months after the assessment date.',
    UNKNOWN_HAZARD: 'A control measure refers to a removed hazard.',
    DUPLICATE_ID: 'A hazard or control measure is duplicated.',
    REASON_REQUIRED: 'Enter a reason (at least 5 characters).',
    REASON_TOO_LONG: 'The reason is too long.',
    NO_CHANGE: 'Nothing changed since the last revision.',
    RA_LOCKED: 'The assessment is waiting for approval or withdrawn; it cannot be changed.',
    ALREADY_SUBMITTED: 'The assessment is already waiting for approval.',
    NOT_PENDING: 'The assessment is not waiting for approval.',
    NOT_APPROVER: 'Your role does not approve this step.',
    SELF_APPROVAL_FORBIDDEN: 'You cannot approve an assessment you wrote or submitted.',
    RETURN_REASON_REQUIRED: 'Enter the reason for returning.',
    OFFICE_STEP: 'This step is approved in the office.',
    NOT_OFFICE_STEP: 'This step is approved on board.',
    NO_ELIGIBLE_APPROVER: 'Nobody on board can approve this step today.',
    STALE_DECISION: 'The assessment changed meanwhile. Reopen it and try again.',
    DISCARD_NOT_ALLOWED: 'A submitted assessment cannot be discarded; withdraw it.',
    UNKNOWN_TEMPLATE: 'The template is no longer in the library.',
    TEMPLATE_ARCHIVED: 'The template is archived.',
    SHIP_IS_WRITER: 'Risk assessments are written on board.',
    OFFICE_IS_WRITER: 'The template library is managed in the office.',
    SAME_APPROVER_FORBIDDEN: 'You already approved an earlier step of this assessment.',
    CONTENT_CHANGED: 'The assessment changed meanwhile. Reopen it and try again.',
    NOT_ALLOWED_TO_SUBMIT: 'Your role cannot submit this assessment.',
    APPROVAL_RULE_MISSING: 'The approval matrix has no rule for risk assessments. Ask the office.',
    RECORD_VOID: 'The assessment is withdrawn.',
  },
};

export const riskTr: typeof riskEn = {
  title: 'Risk Assessment',
  crumbList: 'Risk Değerlendirme Listesi',
  description:
    'Gemideki işlerin risk değerlendirmeleri (ISM 1.2.2.2): tehlikeler, önlemlerden önce ve sonra 5×5 puanlama, onay ve gözden geçirme.',
  newAssessment: 'Yeni Risk Değerlendirmesi',
  export: 'Dışa aktar',
  print: 'Yazdır',
  kpi: {
    total: 'Toplam Risk',
    totalNote: 'Listedeki değerlendirmeler',
    high: 'Yüksek Risk',
    highNote: 'Aksiyon gerekli',
    medium: 'Orta Risk',
    mediumNote: 'İzlemede',
    low: 'Düşük Risk',
    lowNote: 'Kontrol altında',
  },
  filter: {
    label: 'Risk değerlendirmelerini süz',
    vessel: 'Gemi',
    allVessels: 'Bütün gemiler',
    department: 'Departman',
    allDepartments: 'Bütün departmanlar',
    category: 'Risk kategorisi',
    allCategories: 'Bütün kategoriler',
    level: 'Risk seviyesi',
    allLevels: 'Bütün seviyeler',
    status: 'Durum',
    allStatuses: 'Bütün durumlar',
    from: 'Değerlendirme başı',
    to: 'Değerlendirme sonu',
    search: 'Ara',
    text: 'Başlık ya da numara',
    cell: 'Matris: olasılık {{likelihood}} × etki {{severity}}',
    clearCell: 'Matris süzgecini kaldır',
  },
  matrix: {
    title: '1. Risk Matrisi',
    likelihood: 'Olasılık',
    impact: 'Etki',
    initial: 'İlk risk',
    residual: 'Kalan risk',
    mode: 'Gösterilen risk',
    cell: 'Olasılık {{likelihood}}, etki {{severity}}: {{count}} değerlendirme. Listede göster.',
  },
  list: {
    title: '2. Risk Listesi',
    table: 'Risk değerlendirmeleri',
    columns: {
      no: 'No',
      raNo: 'RA No',
      title: 'Başlık',
      vessel: 'Gemi',
      department: 'Departman',
      level: 'Risk seviyesi',
      score: 'Skor',
      status: 'Durum',
      actions: 'İşlemler',
    },
    view: '{{no}} görüntüle',
    edit: '{{no}} düzenle',
    showing: '{{total}} kayıttan {{from}}–{{to}} gösteriliyor',
    pagination: 'Risk listesi sayfaları',
    emptyTitle: 'Henüz risk değerlendirmesi yok',
    emptyShip:
      'Aşağıdaki kütüphaneden bir senaryoyla ya da Yeni Risk Değerlendirmesi ile başlayın.',
    emptyWeb: 'Risk değerlendirmeleri gemide yazılır ve senkronla ofise gelir.',
    noMatch: 'Süzgeçlere uyan risk değerlendirmesi yok',
    error: 'Risk değerlendirmeleri yüklenemedi.',
    unscored: 'Puanlanmadı',
    changed: 'Revizyon hazırlanıyor',
    office: 'Ofis',
  },
  form: {
    title: '3. Risk Değerlendirme Formu (Yeni/Düzenle)',
    noneTitle: 'Bir risk değerlendirmesi seçin',
    noneText: 'Listeden seçin ya da yenisini başlatın.',
    tabs: {
      general: 'Genel',
      details: 'Risk Ayrıntıları',
      controls: 'Kontrol Önlemleri',
      history: 'Revizyon Geçmişi',
    },
    vessel: 'Gemi',
    department: 'Departman',
    category: 'Risk kategorisi',
    titleField: 'Başlık',
    activity: 'Açıklama',
    location: 'Yer',
    likelihood: 'O (Olasılık)',
    impact: 'E (Etki)',
    level: 'Risk seviyesi',
    residual: 'Kalan risk',
    assessedBy: 'Değerlendiren',
    assessmentDate: 'Değerlendirme tarihi',
    reviewDate: 'Gözden geçirme tarihi',
    template: '{{code}} şablonundan (sürüm {{version}})',
    source: "{{code}} şirket RA'sından",
    revision: 'Revizyon {{no}}',
    inForce: 'Yürürlükte: revizyon {{no}}',
    save: 'Kaydet',
    cancel: 'Vazgeç',
    saved: 'Kaydedildi.',
    submit: 'Onaya gönder',
    submitRevision: 'Revizyonu gönder',
    approve: 'Onayla',
    return: 'İade et',
    withdraw: 'Geri çek',
    discard: 'Taslaktan vazgeç',
    readOnlyOffice: 'Risk değerlendirmeleri gemide yazılır. Ofis inceler ve onaylar.',
    pendingShip: 'Gemide {{steps}} adımdan {{step}}. adımın onayını bekliyor.',
    pendingOffice: 'Ofis onayını bekliyor ({{steps}} adımdan {{step}}.).',
    returnedNote: 'İade edildi. Düzeltip gerekçeyle yeniden gönderin.',
    changedNote: 'Son gönderimden sonra değişiklik var. Gerekçeyle yeni revizyon olarak gönderin.',
    hazards: {
      add: 'Tehlike ekle',
      hazard: 'Tehlike',
      consequence: 'Sonuç / kim etkilenir',
      likelihood: 'O',
      severity: 'E',
      initial: 'İlk',
      residualLikelihood: 'Kalan O',
      residualSeverity: 'Kalan E',
      residual: 'Kalan',
      remove: '{{n}}. tehlikeyi kaldır',
      empty: 'Henüz tehlike yok. Bu işin tehlikelerini ekleyin.',
      table: 'Tehlikeler',
    },
    controls: {
      hazard: 'Tehlike',
      general: 'Genel',
      remove: '{{n}}. kontrol önlemini kaldır',
      table: 'Düzenlenen kontrol önlemleri',
    },
    matrix: 'Risk matrisi: {{name}}',
    history: {
      matrix: 'Risk matrisi: {{name}}',
      empty: 'Henüz gönderilmedi. İlk gönderim revizyon 1 olur.',
      submitted: '{{at}} tarihinde {{by}} gönderdi',
      reason: 'Gerekçe: {{reason}}',
      decision: '{{step}}. adım: {{at}} tarihinde {{by}} ({{role}}) {{decision}}',
      office: 'ofis',
      outcomes: {
        pending: 'Bekliyor',
        approved: 'Onaylandı',
        returned: 'İade edildi',
        superseded: 'Yenisi geldi',
      },
    },
  },
  controls: {
    title: '4. Kontrol Önlemleri',
    table: 'Kontrol önlemleri',
    columns: {
      type: 'Tür',
      measure: 'Kontrol önlemi',
      responsible: 'Sorumlu',
      dueDate: 'Son tarih',
      status: 'Durum',
    },
    add: 'Kontrol Önlemi Ekle',
    empty: 'Henüz kontrol önlemi yok.',
    none: 'Kontrol önlemlerini görmek için bir risk değerlendirmesi seçin.',
  },
  guide: {
    title: '5. Risk Puanlama Rehberi',
    impact: 'Etki (Şiddet)',
    likelihood: 'Olasılık',
    severity: {
      1: 'Hafif (ilk yardım)',
      2: 'İş kaybı < 1 gün',
      3: 'İş kaybı 1–7 gün',
      4: 'Ağır yaralanma / hasar',
      5: 'Ölüm / büyük kayıp',
    },
    probability: {
      1: 'Nadir (yılda < 1)',
      2: 'Düşük ihtimal (yılda 1–2)',
      3: 'Olası (ayda 1)',
      4: 'Muhtemel (haftada 1)',
      5: 'Neredeyse kesin (sürekli)',
    },
  },
  scale: {
    1: 'Çok Düşük',
    2: 'Düşük',
    3: 'Orta',
    4: 'Yüksek',
    5: 'Çok Yüksek',
  },
  scenarios: {
    title: '6. Risk Senaryoları (Kütüphane)',
    note: 'Şirketin yayımladığı risk değerlendirmeleri. Gemi değerlendirmesi bu gemiye atanmış güncel bir sürümden başlar.',
    use: '{{title}} ile başla',
    empty: 'Şirket henüz risk değerlendirmesi yayımlamadı.',
    error: 'Şirket risk kütüphanesi yüklenemedi.',
    not_assigned: 'Atanmamış',
    superseded: 'Eski sürüm',
  },
  start: {
    title: 'Yeni gemi risk değerlendirmesi',
    version: 'Şirket risk değerlendirmesi',
    help: 'Yalnız bu gemiye atanmış güncel sürümler kullanılabilir.',
    placeholder: 'Yayımlı değerlendirme seçin',
    none: 'Bu gemiye atanmış şirket risk değerlendirmesi yok.',
    residualNote: 'Kalan risk ilk riske eşit başlar: önlemler gemide doğrulanınca düşürün.',
    start: 'Değerlendirmeyi Başlat',
  },
  library: {
    titleNew: 'Yeni şablon',
    titleEdit: '{{code}} şablonunu düzenle',
    code: 'Kod',
    save: 'Şablonu kaydet',
    archive: 'Şablonu arşivle',
    archiveConfirm: 'Bu şablon arşivlensin mi? Gemideki kopyalar etkilenmez.',
    version: 'Sürüm {{version}}',
  },
  tree: {
    title: '7. Karar Ağacı (Risk Değerlendirme Süreci)',
    identified: 'Olay / tehlike belirlendi mi?',
    assess: 'Riski değerlendir (Olasılık × Etki)',
    high: 'Risk seviyesi yüksek mi?',
    plan: 'Aksiyon planı oluştur (önleyici / düzeltici)',
    monitor: 'İzle ve kontrol et',
    yes: 'Evet',
    no: 'Hayır',
    frequency: 'Risk değerlendirme sıklığı',
    when: {
      before: 'Her yeni faaliyet öncesi',
      yearly: 'Yılda en az bir kez',
      change: 'Önemli değişikliklerde',
      incident: 'Olay / kaza sonrası',
    },
  },
  dialog: {
    password: 'Parola',
    reason: 'Gerekçe',
    cancel: 'Vazgeç',
    submitTitle: 'Onaya gönder',
    submitBody:
      'Değerlendirme revizyon {{no}} olur ve sonradan değiştirilemez. İmza için parolanızı girin.',
    approveTitle: 'Risk değerlendirmesini onayla',
    approveBody: 'Revizyon {{no}} gösterildiği haliyle onaylanır. İmza için parolanızı girin.',
    returnTitle: 'Risk değerlendirmesini iade et',
    returnBody: 'Neyin düzeltilmesi gerektiğini yazın. İmza için parolanızı girin.',
    withdrawTitle: 'Risk değerlendirmesini geri çek',
    withdrawBody: 'Değerlendirme geçmişte kalır ve artık kullanılmaz. Geri alınamaz.',
    discardTitle: 'Taslaktan vazgeç',
    discardBody: 'Taslak listeden kalkar; numarası korunur.',
  },
  departments: {
    deck: 'Güverte',
    engine: 'Makine',
    catering: 'Kumanya',
    operations: 'Operasyon',
    crew: 'Personel',
    other: 'Diğer',
  },
  categories: {
    mooring: 'Palamar',
    navigation: 'Seyir',
    cargo: 'Kargo operasyonu',
    fire: 'Yangın',
    chemical: 'Kimyasal maruziyet',
    work_at_height: 'Yüksekte çalışma',
    enclosed_space: 'Kapalı alan',
    hot_work: 'Sıcak çalışma',
    equipment: 'Ekipman arızası',
    fatigue: 'Yorgunluk',
    security: 'Güvenlik',
    other: 'Diğer',
  },
  levels: {
    very_low: 'Çok Düşük',
    low: 'Düşük',
    medium: 'Orta',
    high: 'Yüksek',
    very_high: 'Çok Yüksek',
    critical: 'Kritik',
  },
  statuses: {
    draft: 'Taslak',
    pending: 'Onay bekliyor',
    returned: 'İade edildi',
    approved: 'Onaylandı',
    withdrawn: 'Geri çekildi',
    discarded: 'Vazgeçildi',
  },
  review: {
    due: 'Gözden geçirme yaklaştı',
    overdue: 'Gözden geçirme gecikti',
  },
  controlTypes: {
    elimination: 'Ortadan kaldırma',
    substitution: 'İkame',
    engineering: 'Mühendislik',
    administrative: 'İdari',
    ppe: 'KKD',
    training: 'Eğitim',
  },
  controlStatuses: {
    planned: 'Planlandı',
    open: 'Açık',
    in_progress: 'Sürüyor',
    done: 'Tamamlandı',
  },
  matrixProfile: {
    title: 'Risk Matrisi',
    intro:
      'Skor = olasılık × şiddet (5 × 5). Bantlar ve kabul seviyeleri şirket ayarıdır. Yayımlamak yeni bir sürüm açar; eski sürümler saklanır ve gönderilmiş her değerlendirme gönderildiği sürümle kalır.',
    shipNote: 'Risk matrisi ofiste belirlenir ve gemiye sonraki senkronla iner.',
    profile: 'Profil',
    inUse: 'Kullanımda',
    use: 'Bu profili kullan',
    versionLabel: '{{name}} s{{version}}',
    legacy: 'Eski 5 bant',
    bands: 'Bantlar',
    band: 'Bant',
    score: 'Skor',
    to: 'Üst sınır',
    acceptance: 'Kabul',
    acceptedBy: 'Kabul eden',
    addBand: 'Bant ekle',
    removeBand: '{{n}}. bandı kaldır',
    acceptances: {
      acceptable: 'Kabul edilebilir',
      controls_required: 'Ek önlem gerekir',
      escalation: 'Üst onay gerekir',
      unacceptable: 'Kabul edilemez',
    },
    acceptors: { master: 'Kaptan', superintendent: 'Süperintendent', dpa: 'DPA' },
    preview: 'Önizleme',
    cell: 'Olasılık {{likelihood}} × Şiddet {{severity}} = {{score}}, {{level}}',
    reason: 'Değişikliğin gerekçesi',
    reasonHint: 'En az 5 karakter; sürümle birlikte saklanır.',
    publish: '{{version}}. sürümü yayımla',
    published: '{{version}}. sürüm yayımlandı. Gemilere sonraki senkronla iner.',
    selected: 'Profil değişti. Yeni risk değerlendirmesi revizyonları bunu kullanır.',
    history: 'Sürüm geçmişi',
    historyItem: '{{version}}. sürüm · {{at}} · {{by}}',
    issues: {
      MATRIX_BOUNDS: 'Bantlar 1 ile başlamalı ve 25 ile bitmeli.',
      MATRIX_GAP: '{{n}}. bant ile önceki bant arasında boşluk var.',
      MATRIX_OVERLAP: '{{n}}. bant önceki bantla çakışıyor.',
      MATRIX_EMPTY_BAND: '{{n}}. bant boş: üst sınırı alt sınırından küçük.',
      MATRIX_BAND_ORDER: '{{n}}. bant: bant adları düşükten yükseğe gitmeli.',
      MATRIX_ACCEPTANCE_ORDER: '{{n}}. bant alttaki banttan daha gevşek olamaz.',
      MATRIX_ACCEPTOR_REQUIRED: '{{n}}. bantta kalan riski kabul eden en az bir rol olmalı.',
      MATRIX_ACCEPTOR_NOT_ALLOWED:
        '{{n}}. bant: kabul edilemez bantta kalan riski kimse kabul etmez; bir rol bir kez yazılır.',
    },
    error: 'Risk matrisi kaydedilemedi.',
    retry: 'Yeniden dene',
  },
  errors: {
    GENERIC: 'İşlem yapılamadı. Yeniden deneyin.',
    NETWORK: 'Bağlantı yok. Ağı denetleyip yeniden deneyin.',
    FORBIDDEN: 'Bu işlem için yetkiniz yok.',
    NOT_FOUND: 'Risk değerlendirmesi bulunamadı.',
    INVALID_CREDENTIALS: 'Parola yanlış.',
    INVALID_PASSWORD: 'Parola yanlış.',
    TOO_MANY_ATTEMPTS: 'Çok fazla yanlış parola. 15 dakika bekleyip yeniden deneyin.',
    ROW_VERSION_CONFLICT: 'Bu değerlendirmeyi başkası değiştirdi. Yeniden açıp deneyin.',
    INVALID_RISK_ASSESSMENT: 'Bazı alanlar boş ya da geçersiz.',
    INVALID_RISK_TEMPLATE: 'Şablonun bazı alanları boş ya da geçersiz.',
    ACTIVITY_REQUIRED: 'Göndermeden önce işi açıklayın.',
    NO_HAZARDS: 'En az bir tehlike ekleyin.',
    RESIDUAL_ABOVE_INITIAL: 'Kalan risk ilk riskten yüksek olamaz.',
    CONTROLS_REQUIRED:
      'İlk riski kabul edilebilir bandın üstünde olan her tehlikenin kontrol önlemi olmalı.',
    RESIDUAL_INTOLERABLE: 'Kalan risk risk matrisinin kabul edilemez bandında. Önlem ekleyin.',
    INVALID_RISK_MATRIX: 'Risk matrisi geçersiz.',
    MATRIX_BOUNDS: 'Bantlar 1 ile başlamalı ve 25 ile bitmeli.',
    MATRIX_GAP: 'Bantlar arasında boşluk var.',
    MATRIX_OVERLAP: 'Bantlar çakışıyor.',
    MATRIX_EMPTY_BAND: 'Bir bant boş.',
    MATRIX_BAND_ORDER: 'Bant adları düşükten yükseğe gitmeli.',
    MATRIX_ACCEPTANCE_ORDER: 'Üstteki bant alttakinden daha gevşek olamaz.',
    MATRIX_ACCEPTOR_REQUIRED: 'Üst onay bandında kalan riski kabul eden bir rol olmalı.',
    MATRIX_ACCEPTOR_NOT_ALLOWED: 'Kabul edilemez bantta kalan riski kimse kabul etmez.',
    UNKNOWN_MATRIX_PROFILE: 'Risk matrisi profili bulunamadı.',
    MATRIX_VERSION_MISMATCH: 'Risk matrisi bu arada değişti. Sayfayı yeniden açıp deneyin.',
    FUTURE_DATE: 'Değerlendirme tarihi ileri bir gün olamaz.',
    REVIEW_BEFORE_ASSESSMENT: 'Gözden geçirme tarihi değerlendirme tarihinden sonra olmalı.',
    REVIEW_TOO_LATE: 'Gözden geçirme en çok 12 ay sonra olabilir.',
    UNKNOWN_HAZARD: 'Bir kontrol önlemi kaldırılmış bir tehlikeye bağlı.',
    DUPLICATE_ID: 'Bir tehlike ya da önlem iki kez var.',
    REASON_REQUIRED: 'Gerekçe girin (en az 5 karakter).',
    REASON_TOO_LONG: 'Gerekçe çok uzun.',
    NO_CHANGE: 'Son revizyondan bu yana değişiklik yok.',
    RA_LOCKED: 'Değerlendirme onay bekliyor ya da geri çekildi; değiştirilemez.',
    ALREADY_SUBMITTED: 'Değerlendirme zaten onay bekliyor.',
    NOT_PENDING: 'Değerlendirme onay beklemiyor.',
    NOT_APPROVER: 'Rolünüz bu adımı onaylamaz.',
    SELF_APPROVAL_FORBIDDEN: 'Yazdığınız ya da gönderdiğiniz değerlendirmeyi onaylayamazsınız.',
    RETURN_REASON_REQUIRED: 'İade gerekçesini girin.',
    OFFICE_STEP: 'Bu adım ofiste onaylanır.',
    NOT_OFFICE_STEP: 'Bu adım gemide onaylanır.',
    NO_ELIGIBLE_APPROVER: 'Bugün gemide bu adımı onaylayabilecek kimse yok.',
    STALE_DECISION: 'Değerlendirme bu arada değişti. Yeniden açıp deneyin.',
    DISCARD_NOT_ALLOWED: 'Gönderilmiş değerlendirmeden vazgeçilmez; geri çekin.',
    UNKNOWN_TEMPLATE: 'Şablon artık kütüphanede yok.',
    TEMPLATE_ARCHIVED: 'Şablon arşivlendi.',
    SHIP_IS_WRITER: 'Risk değerlendirmeleri gemide yazılır.',
    OFFICE_IS_WRITER: 'Şablon kütüphanesi ofiste yönetilir.',
    SAME_APPROVER_FORBIDDEN: 'Bu değerlendirmenin önceki bir adımını zaten onayladınız.',
    CONTENT_CHANGED: 'Değerlendirme bu arada değişti. Yeniden açıp deneyin.',
    NOT_ALLOWED_TO_SUBMIT: 'Rolünüz bu değerlendirmeyi gönderemez.',
    APPROVAL_RULE_MISSING: 'Onay matrisinde risk değerlendirmesi kuralı yok. Ofise danışın.',
    RECORD_VOID: 'Değerlendirme geri çekildi.',
  },
};
